/**
 * Key for our pro subscription of ip-api (https://ip-api.com/) - used for
 * geolocating and pre-populating user's locations on the homepage.
 *
 * Keeping the key here is fine (origin restrictions make it usable only for CAN)
 *
 * Note: only works on prod + main staging. Won't work locally or in preview links.
 */
export const IP_API_KEY = '5xnFKRlZSFmdOrN';
